













import { Vue, Component } from 'vue-property-decorator';
import TopNavbar from '@/components/brand/TopNavbar.vue';
import BottomFooter from '@/components/brand/BottomFooter.vue';
import budtenderModule from '../../store/modules/budtender.module';
import errorModule from '../../store/modules/error.module';
import brandModule from '../../store/modules/brand.module';
import { BUDTENDER_PORTAL } from '../../common/routes.config';

@Component({
  components: {
    TopNavbar,
    BottomFooter,
  },
})
export default class BrandRoot extends Vue {
  async mounted(): Promise<void> {
    if (!budtenderModule.selectedBrand) {
      this.$router.push(BUDTENDER_PORTAL);
      return;
    }
    await brandModule.fetchBrandForBudtender(budtenderModule.selectedBrand.id);
    errorModule.clearError();
  }
}
